import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";

export const StyledBaseCell = styled(BaseCell)`
    display: inline-flex;
    justify-content: center;
    width: 100%;
`;
